import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Selector del MODELO DE LA CONVERSACIÓN (piloto de Claude Haiku 5.5, 13-oct-2026). Sólo lo ve
 * el equipo de PUX (lo decide el panel). Escribe `modeloConversacion` en
 * `bots/{botId}/integrations/config`, que lee `functions/bot/llm/modeloDeConversacion.js`: sin
 * campo o con cualquier valor fuera de su lista, OpenAI.
 *
 * `onUpdate` es el `handleUpdate` del panel: devuelve true/false y él da el aviso. Si no guardó,
 * el selector vuelve a lo que había (el bug que tenía SeguimientoAutoConfig no se repite aquí).
 */
export const OPCIONES = Object.freeze([
  { valor: 'openai', clave: 'openai' },
  { valor: 'claude-haiku-5-5', clave: 'haiku' },
]);

export function valorActual(config) {
  const v = config?.modeloConversacion;
  return OPCIONES.some((o) => o.valor === v) ? v : 'openai';
}

export default function ModeloConversacionConfig({ config, onUpdate }) {
  const { t } = useTranslation('bots');
  const [valor, setValor] = useState(valorActual(config));
  const [saving, setSaving] = useState(false);

  useEffect(() => { setValor(valorActual(config)); }, [config?.modeloConversacion]);

  const cambiar = async (nuevo) => {
    const anterior = valor;
    setValor(nuevo);
    setSaving(true);
    try {
      if ((await onUpdate({ modeloConversacion: nuevo })) !== true) setValor(anterior);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="modelo-conversacion" style={{ background: 'white', border: '1px dashed #a0aec0', borderRadius: '8px', padding: '1.5rem', marginTop: '1rem' }}>
      <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1.1rem' }}>{t('integrations.modeloConversacion.title')}</h3>
      <p style={{ color: '#718096', fontSize: '0.875rem', margin: '0 0 1rem 0' }}>{t('integrations.modeloConversacion.desc')}</p>
      <select aria-label={t('integrations.modeloConversacion.title')} value={valor} disabled={saving} onChange={(e) => cambiar(e.target.value)}>
        {OPCIONES.map((o) => (
          <option key={o.valor} value={o.valor}>{t(`integrations.modeloConversacion.${o.clave}`)}</option>
        ))}
      </select>
    </div>
  );
}
